/* ==========================================================================
   Palmora — JS cho khối sản phẩm chính (pm-main-product) + thanh mua dính (pm-sticky-atc).
   - Chỉ BỔ SUNG cho form gốc: không có JS thì {% form 'product' %} vẫn gửi /cart/add bình thường.
   - Thư viện media: dải thumbnail + mũi tên (desktop), trượt ngang + chấm + bộ đếm (điện thoại),
     phím ← → trên khung media.
   - Biến thể: đọc JSON nhúng [data-pm-product-json], đổi giá / nút mua / URL ?variant= / media.
   - Chống bấm mua hai lần. Thanh mua dính hiện khi nút mua chính đã cuộn khuất, ẩn gần footer.
   - IIFE, chạy được nhiều lần (mỗi section tự nạp file) và theo dõi shopify:section:load/unload.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pmProductBooted) return;
  window.__pmProductBooted = true;

  var VARIANT_EVENT = 'pm:variant-change';
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var stickies = [];

  /* ------------------------------------------------------------------------
     Tiện ích
     ------------------------------------------------------------------------ */
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function attached(el) {
    return !!el && document.documentElement.contains(el);
  }

  function isMobile() {
    return !!(mqMobile && mqMobile.matches);
  }

  function reduceMotion() {
    return !!(mqReduce && mqReduce.matches);
  }

  /* Phần tử scope (nếu khớp) + mọi phần tử con khớp selector */
  function collect(scope, selector) {
    if (!scope || !scope.querySelectorAll) return [];
    var list = toArray(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) list.unshift(scope);
    return list;
  }

  function makeEvent(name, detail, bubbles) {
    var ev;
    try {
      ev = new CustomEvent(name, { bubbles: !!bubbles, detail: detail });
    } catch (err) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, !!bubbles, false, detail);
    }
    return ev;
  }

  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function scrollBox(el, left, smooth) {
    if (!el) return;
    if (typeof el.scrollTo === 'function') {
      try {
        el.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
        return;
      } catch (err) { /* trình duyệt cũ: gán trực tiếp bên dưới */ }
    }
    el.scrollLeft = left;
  }

  function setCurrent(el, on) {
    el.classList.toggle('is-active', on);
    if (on) el.setAttribute('aria-current', 'true');
    else el.removeAttribute('aria-current');
  }

  /* Dừng video trong một slide: <video> gốc + iframe YouTube/Vimeo (qua postMessage) */
  function pauseMedia(slide) {
    toArray(slide.querySelectorAll('video')).forEach(function (video) {
      if (!video.paused) video.pause();
    });
    toArray(slide.querySelectorAll('iframe')).forEach(function (frame) {
      var src = frame.getAttribute('src') || '';
      if (!frame.contentWindow) return;
      if (src.indexOf('youtube') !== -1) {
        frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (src.indexOf('vimeo') !== -1) {
        frame.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    });
  }

  /* ------------------------------------------------------------------------
     Thư viện media
     ------------------------------------------------------------------------ */
  function initGallery(root) {
    var gallery = root.querySelector('[data-pm-gallery]');
    var track = gallery ? gallery.querySelector('[data-pm-track]') : null;
    if (!track) return null;

    var slides = toArray(track.querySelectorAll('[data-pm-slide]'));
    var thumbs = toArray(gallery.querySelectorAll('[data-pm-thumb]'));
    var dots = toArray(gallery.querySelectorAll('[data-pm-dot]'));
    var thumbList = gallery.querySelector('[data-pm-thumbs]');
    var prevBtn = gallery.querySelector('[data-pm-prev]');
    var nextBtn = gallery.querySelector('[data-pm-next]');
    var counter = gallery.querySelector('[data-pm-counter]');
    var index = 0;
    var lockUntil = 0;
    var frame = 0;
    var resizeTimer = 0;

    if (slides.length < 2) {
      return { showMedia: function () {}, destroy: function () {} };
    }

    function indexOfId(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) return i;
      }
      return -1;
    }

    function revealThumb(i, smooth) {
      var thumb = thumbs[i];
      if (!thumb || !thumbList || !thumbList.clientWidth) return;
      var item = thumb.parentNode;
      var target = item.offsetLeft - (thumbList.clientWidth - item.offsetWidth) / 2;
      scrollBox(thumbList, Math.max(0, target), !!smooth && !reduceMotion());
    }

    function mark(i, smooth) {
      var changed = i !== index;
      index = i;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === i);
        if (changed && n !== i) pauseMedia(slide);
      });
      thumbs.forEach(function (thumb, n) { setCurrent(thumb, n === i); });
      dots.forEach(function (dot, n) { setCurrent(dot, n === i); });
      if (counter) counter.textContent = String(i + 1);
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === slides.length - 1;
      revealThumb(i, smooth);
    }

    /* Desktop đổi media tức thì (giống "đổi khung chính"); điện thoại trượt mượt */
    function go(i, smooth) {
      if (i < 0 || i >= slides.length) return;
      var useSmooth = !!smooth && isMobile() && !reduceMotion();
      lockUntil = Date.now() + (useSmooth ? 650 : 80);
      scrollBox(track, slides[i].offsetLeft, useSmooth);
      mark(i, smooth);
    }

    function syncFromScroll() {
      frame = 0;
      if (Date.now() < lockUntil || !track.clientWidth) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      if (i !== index) mark(i, true);
    }

    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(syncFromScroll);
    }

    /* Phím chỉ áp dụng khi chính khung media đang focus (không chặn phím của trình phát video bên trong) */
    function onKeydown(event) {
      if (event.target !== track) return;
      var key = event.key;
      var target = null;
      if (key === 'ArrowLeft') target = index - 1;
      else if (key === 'ArrowRight') target = index + 1;
      else if (key === 'Home') target = 0;
      else if (key === 'End') target = slides.length - 1;
      if (target === null) return;
      event.preventDefault();
      go(Math.max(0, Math.min(slides.length - 1, target)), true);
    }

    function onResize() {
      if (!attached(track)) {
        destroy();
        return;
      }
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        lockUntil = Date.now() + 80;
        scrollBox(track, slides[index].offsetLeft, false);
        revealThumb(index, false);
      }, 150);
    }

    function onThumbClick(event) {
      var btn = event.currentTarget;
      var i = thumbs.indexOf(btn);
      if (i === -1) i = dots.indexOf(btn);
      if (i !== -1) go(i, true);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', onKeydown);
    thumbs.concat(dots).forEach(function (btn) { btn.addEventListener('click', onThumbClick); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1, true); });
    window.addEventListener('resize', onResize);

    function destroy() {
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    }

    /* Trạng thái đầu: đưa media của biến thể đang chọn vào khung, không animation */
    var start = indexOfId(gallery.getAttribute('data-active-id'));
    index = -1;
    go(start > 0 ? start : 0, false);

    return {
      showMedia: function (mediaId) {
        var i = indexOfId(mediaId);
        if (i !== -1 && i !== index) go(i, true);
      },
      destroy: destroy
    };
  }

  /* ------------------------------------------------------------------------
     Chống bấm mua hai lần (form gốc vẫn tự gửi)
     ------------------------------------------------------------------------ */
  function submitButtons(form) {
    /* form.elements gồm cả nút ngoài form có thuộc tính form="…" (nút của thanh mua dính) */
    return toArray(form.elements).filter(function (el) {
      return el.type === 'submit';
    });
  }

  function setBusy(form, on) {
    form.__pmBusy = !!on;
    clearTimeout(form.__pmBusyTimer);
    submitButtons(form).forEach(function (btn) {
      btn.classList.toggle('is-loading', !!on);
      if (on) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    });
    /* Chốt an toàn: trang chưa chuyển sau 10 giây (mạng chậm, lỗi) thì cho bấm lại */
    if (on) form.__pmBusyTimer = setTimeout(function () { setBusy(form, false); }, 10000);
  }

  function guardSubmit(form) {
    if (!form || form.__pmGuarded) return;
    form.__pmGuarded = true;

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (form.__pmBusy || (submitter && submitter.disabled)) {
        event.preventDefault();
        return;
      }
      setBusy(form, true);
      /* Một app giỏ hàng khác chặn gửi để tự thêm bằng AJAX => không giữ trạng thái "đang gửi" */
      setTimeout(function () {
        if (event.defaultPrevented) setBusy(form, false);
      }, 0);
    });

    /* Quay lại bằng nút Back (bfcache): nhả trạng thái đang gửi để bấm lại được */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted && attached(form)) setBusy(form, false);
    });
  }

  /* ------------------------------------------------------------------------
     Khối sản phẩm chính
     ------------------------------------------------------------------------ */
  function initProduct(root) {
    if (!root || root.__pmProduct) return;

    var gallery = initGallery(root);
    root.__pmProduct = {
      destroy: function () {
        if (gallery) gallery.destroy();
      }
    };

    var atc = root.querySelector('[data-pm-atc]');
    var form = atc ? atc.form : null;
    guardSubmit(form);

    var data = parseJSON(root.querySelector('[data-pm-product-json]'));
    if (!data || !data.variants || !data.variants.length) return;

    var variants = data.variants;
    var labels = data.labels || {};
    var groups = toArray(root.querySelectorAll('[data-pm-option]'));
    var idInputs = toArray(root.querySelectorAll('[data-pm-variant-id]'));
    var atcLabel = root.querySelector('[data-pm-atc-label]');
    var priceWrap = root.querySelector('[data-pm-price]');
    var priceCurrent = root.querySelector('[data-pm-price-current]');
    var priceLabel = root.querySelector('[data-pm-price-label]');
    var compareWrap = root.querySelector('[data-pm-price-compare-wrap]');
    var compareEl = root.querySelector('[data-pm-price-compare]');
    var badge = root.querySelector('[data-pm-price-badge]');

    if (!groups.length) return; /* sản phẩm một biến thể: không cần đổi gì */
    root.classList.add('is-enhanced');

    function currentOptions() {
      return groups.map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (!v.options || v.options[j] !== opts[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Đánh dấu giá trị không mua được khi ghép với các tuỳ chọn đang chọn */
    function updateOptionStates(opts) {
      groups.forEach(function (group, idx) {
        var valueEl = group.querySelector('[data-pm-option-value]');
        if (valueEl) valueEl.textContent = opts[idx] || '';
        toArray(group.querySelectorAll('input[type="radio"]')).forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var match = findVariant(test);
          var label = input.nextElementSibling;
          if (!label) return;
          var status = label.querySelector('[data-pm-value-status]');
          var text = '';
          if (!match) text = labels.unavailable || 'Unavailable';
          else if (!match.available) text = labels.soldout || 'Sold out';
          label.classList.toggle('is-unavailable', text !== '');
          if (status) status.textContent = text ? ' (' + text + ')' : '';
        });
      });
    }

    function updatePrice(v) {
      /* Tổ hợp không tồn tại: ẩn giá cũ thay vì để khách thấy giá của biến thể khác */
      if (priceWrap) priceWrap.classList.toggle('is-unavailable', !v);
      if (!v) return;
      if (priceCurrent) priceCurrent.textContent = v.price;
      if (priceLabel) priceLabel.textContent = v.onSale ? 'Sale price' : 'Price';
      if (compareEl) compareEl.textContent = v.onSale ? v.compare : '';
      if (compareWrap) compareWrap.hidden = !v.onSale;
      if (badge) badge.hidden = !v.onSale;
      if (priceWrap) priceWrap.classList.toggle('is-on-sale', !!v.onSale);
    }

    function updateButton(v) {
      if (!atc) return;
      var ok = !!(v && v.available);
      atc.disabled = !ok;
      if (atcLabel) {
        if (!v) atcLabel.textContent = labels.unavailable || 'Unavailable';
        else atcLabel.textContent = ok ? (labels.atc || 'Add to cart') : (labels.soldout || 'Sold out');
      }
    }

    /* Ghi id biến thể vào mọi ô id (form mua + form trả góp) và báo cho Shop Pay cập nhật */
    function updateIds(v) {
      if (!v) return;
      idInputs.forEach(function (input) {
        if (String(input.value) === String(v.id)) return;
        input.value = v.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function updateUrl(v) {
      if (!data.updateUrl || !v || !window.history || typeof window.history.replaceState !== 'function') return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (err) { /* bỏ qua */ }
    }

    function sync(fromUser) {
      var opts = currentOptions();
      var v = findVariant(opts);
      updateOptionStates(opts);
      updateIds(v);
      updatePrice(v);
      updateButton(v);
      if (fromUser) {
        updateUrl(v);
        if (v && v.mediaId && gallery) gallery.showMedia(v.mediaId);
      }
      document.dispatchEvent(makeEvent(VARIANT_EVENT, {
        productId: data.productId,
        variant: v
      }));
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function (event) {
        if (event.target && event.target.type === 'radio') sync(true);
      });
    });

    sync(false);
  }

  /* ------------------------------------------------------------------------
     Thanh mua dính
     ------------------------------------------------------------------------ */
  function findFooter() {
    return document.getElementById('shopify-section-footer') ||
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer');
  }

  function initSticky(bar) {
    if (!bar || bar.__pmSticky) return;

    var productId = bar.getAttribute('data-product-id');
    var btn = bar.querySelector('[data-pm-sticky-btn]');
    var btnLabel = bar.querySelector('[data-pm-sticky-label]');
    var priceEl = bar.querySelector('[data-pm-sticky-price]');
    var imgEl = bar.querySelector('[data-pm-sticky-img]');
    var labelOn = bar.getAttribute('data-label') || 'Add to cart';
    var labelOff = bar.getAttribute('data-soldout-label') || 'Sold out';
    var state = { past: false, nearFooter: false, forced: false };
    var atc = null;
    var footer = null;
    var io = null;
    var frame = 0;
    var destroyed = false;

    function render() {
      if (destroyed) return;
      if (!attached(bar)) {
        destroy();
        return;
      }
      var show = state.forced || (!!atc && state.past && !state.nearFooter);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function findAtc() {
      var scoped = document.querySelector('[data-pm-section="main-product"][data-product-id="' + productId + '"] [data-pm-atc]');
      return scoped || null;
    }

    /* Dự phòng khi không có IntersectionObserver: đo trực tiếp khi cuộn */
    function measure() {
      frame = 0;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (atc) state.past = atc.getBoundingClientRect().bottom < 0;
      if (footer) state.nearFooter = footer.getBoundingClientRect().top < vh + 80;
      render();
    }

    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(measure);
    }

    function observe() {
      if (io) io.disconnect();
      atc = findAtc();
      footer = findFooter();
      state.past = false;
      state.nearFooter = false;

      if ('IntersectionObserver' in window) {
        /* rootMargin dưới 80px: coi như "gần footer" trước khi footer thật sự vào màn hình */
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === atc) {
              state.past = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            } else if (entry.target === footer) {
              state.nearFooter = entry.isIntersecting;
            }
          });
          render();
        }, { rootMargin: '0px 0px 80px 0px' });
        if (atc) io.observe(atc);
        if (footer) io.observe(footer);
      } else {
        measure();
      }
      render();
    }

    function onVariantChange(event) {
      if (!attached(bar)) {
        destroy();
        return;
      }
      var detail = event.detail || {};
      if (String(detail.productId) !== String(productId)) return;
      var v = detail.variant;
      var ok = !!(v && v.available);
      if (btn) btn.disabled = !ok;
      if (btnLabel) btnLabel.textContent = ok ? labelOn : labelOff;
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (imgEl && v.image && imgEl.getAttribute('src') !== v.image) imgEl.setAttribute('src', v.image);
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      if (io) io.disconnect();
      io = null;
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener(VARIANT_EVENT, onVariantChange);
      var i = stickies.indexOf(api);
      if (i !== -1) stickies.splice(i, 1);
    }

    var api = {
      el: bar,
      refresh: observe,
      force: function (on) {
        state.forced = !!on;
        render();
      },
      destroy: destroy
    };
    bar.__pmSticky = api;
    stickies.push(api);

    if (!('IntersectionObserver' in window)) window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener(VARIANT_EVENT, onVariantChange);

    observe();
  }

  /* ------------------------------------------------------------------------
     Khởi tạo + Theme Editor
     ------------------------------------------------------------------------ */
  function initAll(scope) {
    collect(scope, '[data-pm-section="main-product"]').forEach(initProduct);
    collect(scope, '[data-pm-section="sticky-atc"]').forEach(initSticky);
  }

  function stickyIn(target) {
    var list = collect(target, '[data-pm-section="sticky-atc"]');
    return list.length && list[0].__pmSticky ? list[0].__pmSticky : null;
  }

  function boot() {
    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
      /* Khối sản phẩm vừa render lại => thanh dính phải theo dõi nút mua MỚI */
      stickies.slice().forEach(function (sticky) { sticky.refresh(); });
    });

    document.addEventListener('shopify:section:unload', function (event) {
      collect(event.target, '[data-pm-section="main-product"]').forEach(function (root) {
        if (root.__pmProduct) root.__pmProduct.destroy();
      });
      collect(event.target, '[data-pm-section="sticky-atc"]').forEach(function (bar) {
        if (bar.__pmSticky) bar.__pmSticky.destroy();
      });
    });

    document.addEventListener('shopify:section:select', function (event) {
      var sticky = stickyIn(event.target);
      if (sticky) sticky.force(true);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var sticky = stickyIn(event.target);
      if (sticky) sticky.force(false);
    });

    /* Chọn block xổ xuống trong Theme Editor => mở hàng đó */
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('[data-pm-acc]')) target.open = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
